import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import MachineList from '../components/MachineList'
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import { Link } from 'react-router';
import PageLoading from '../components/PageLoading';
import {dateStr, dateAndTime} from '../utils/TimeFormatter';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RC from '../utils/ReactiveClock';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import {uiMsg} from '../utils/Languages';

let pageStyle = {
  margin:"1em",
};

let headerStyle = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "20px",
  fontWeight: "400",
  height: "48px",
  lineHeight: "48px"
}

const formStyle = {
  marginLeft: 16
};

function handlePropertyValue(prop) {
  return function handleValueChange(event) {
    var value = event.target.value;
    console.log(value);
    prop.value = value;
  }
}

function handleCheckboxToggle(prop) {
  return function() {
    prop.value=!prop.value;
  }
}

function renderParamInputField(param) {
  if(param.id_type=='String') return <TextField
    key={param.id_property}
    hintText={param.default_value}
    data-propname={param.id_property}
    value={param.value==null ? param.default_value : param.value }
    onChange={handlePropertyValue(param)}
    fullWidth={true}
    floatingLabelText={param.id_property}
    errorText={ !param.value_valid ? param.invalid_message : "" }
  />
  if(param.id_type=='Int') return <TextField
    key={param.id_property}
    hintText={param.default_value}
    data-propname={param.id_property}
    value={param.value==null ? param.default_value : param.value }
    onChange={handlePropertyValue(param)}
    fullWidth={true}
    floatingLabelText={param.id_property}
    errorText={ !param.value_valid ? param.invalid_message : "" }
  />
  if(param.id_type=='Double') return <TextField
    key={param.id_property}
    hintText={param.default_value}
    data-propname={param.id_property}
    value={param.value==null ? param.default_value : param.value }
    onChange={handlePropertyValue(param)}
    fullWidth={true}
    floatingLabelText={param.id_property}
    errorText={ !param.value_valid ? param.invalid_message : "" }
  />
  if(param.id_type=='Bool') return <div key={param.id_property}>
    <List style={{paddingLeft:'0px', marginLeft:'-16px'}}>
      <ListItem
        rightToggle={
          <Checkbox
            data-propname="deleted"
            checked={param.value==null ? param.default_value : param.value }
            onCheck={handleCheckboxToggle(param)}
            />
        }
        primaryText={param.id_property}
      />
    </List>
  </div>
  return <div key={param.id_property}>Not supporterd Input type: {param.id_type}</div>
}

function showMachineConfiguration(form) {
  return <div style={formStyle}>
      {form.parameters.map(renderParamInputField)}
    </div>
}

export default
@observer class MachineEditConfigPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  cancelUpdate() {
    AppModel.machineConfigurationForm.reset();
    this.context.router.goBack();
  }

  performUpdate() {
    return AppModelUtils.updateMachineConfiguration()
    .then(()=> {
      this.context.router.push(`/machine/${AppModel.currentMachine.id}`)
      return null;
    })
    .catch(()=> {
      console.log("Machine Config update rejected.");
    });
  }

  resetToDefaults() {    
      if (confirm(uiMsg('MEC_CONFIRM_RESET',"The configuration will be reset to default configuration. Do you want to proceed?"))) {
        return AppModelUtils.resetToDefaults()
          .then(() => {
            let form = AppModel.machineConfigurationForm;
            let machine = AppModel.currentMachine;
            form.parameters.id_machine = machine.id;
            AppModelUtils.fetch_machine_config_details(form.parameters)
            return null;
          })
          .catch((e) => {
            console.log("Machine Config reset rejected.", e);
          });
      } else {
        return null;
      }    
  }

  render() {
    let form = AppModel.machineConfigurationForm;
    let machine = AppModel.currentMachine;
    return (
      <div style={pageStyle}>
        <PageLoading loading={machine.loading || AppModel.updatingMachineConfig}>
          <h2 style={headerStyle}>Configuration for {machine.id}</h2>
          {AppModel.canRegisterMachines?
            showMachineConfiguration(form)
            :<div>You do not have sufficient permissions to edit machine configuration</div>
          }
          <Toolbar>
            <ToolbarGroup firstChild={true}></ToolbarGroup>
            <ToolbarGroup lastChild={true}>
              <FlatButton
                      onTouchTap={this.resetToDefaults.bind(this)}>{uiMsg('MEC_RESET',"Reset")}
              </FlatButton>
              <FlatButton
                      onTouchTap={this.cancelUpdate.bind(this)}>{uiMsg('MEC_CANCEL',"Cancel")}
              </FlatButton>
              <RaisedButton primary
                            onTouchTap={this.performUpdate.bind(this)}>
                            {uiMsg('MEC_UPDATE',"Update")}
              </RaisedButton>
            </ToolbarGroup>
          </Toolbar>
          {/* added some space at the bottom to allow some scrolling */}
          <div style={{height:"3em"}}></div>
        </PageLoading>
      </div>
    );
  }

};

// <li>id={contract.id}</li>
// <li>delivery={dateStr(contract.delivery)}</li>



/** WEBPACK FOOTER **
 ** ./src/pages/MachineEditConfigPage.jsx
 **/